export var Requirement;
(function (Requirement) {
    Requirement["REQUIRED"] = "required";
    Requirement["OPTIONAL"] = "optional";
    Requirement["FORBIDDEN"] = "forbidden";
})(Requirement || (Requirement = {}));
